module.exports = __webpack_public_path__ + "static/img/quote2.812c348.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/quote2.jpg
// module id = MtZD
// module chunks = 0